export const cleanupAmount = (amount: string, defaultValue = "0") => {
  const [first, ...others] = (amount || "").toString().split(".");
  return [first || defaultValue, others.join("")].filter(Boolean).join(".").replace(/[^\d.]/g, "");
};

export const substringAmount = (amount: number) => {
  const intAmount = amount ? Math.trunc(amount).toLocaleString() : "0";
  const floatAmount = (amount % 1).toFixed(2).substring(2);

  return `${intAmount}.${floatAmount}`;
};

export const isValidAmount = (value: string) => {
  if (value === "") return true;
  const amount = cleanupAmount(value);
  const regex = /^(0(\.\d*)?|[1-9]\d*(\.\d*)?)$/;

  return regex.test(amount);
};

export const isValidAmountInput = (value: string) => {
  if (value === "") return true;
  const amount = cleanupAmount(value);
  const regex = /^(0(\.\d{1,2})?|[1-9]\d*(\.\d{0,2})?)$/;

  return regex.test(amount);
};


export const getAmountOrNull = (amount?: string | number | null) => {
  if (amount === "" || amount === null || amount === undefined) return null;
  return isNaN(+amount) ? null : +amount;
};
